import styled from 'styled-components';
import { ifProp, palette } from 'styled-tools';

import { FocusRingVariants, IconButton, IconButtonProps } from '@calm-web/design-system';

import BackButtonIcon from 'icons/back-button.svg';

interface WrapperProps {
	$isWhite?: boolean;
}

export const Wrapper = styled(IconButton).attrs<
	WrapperProps,
	Pick<IconButtonProps, 'Icon' | 'focusRingVariant' | 'color'>
>(p => ({
	Icon: BackButtonIcon,
	focusRingVariant: p.$isWhite ? FocusRingVariants.Light : FocusRingVariants.Dark,
	color: p.$isWhite ? 'white' : 'gray6',
}))<WrapperProps>`
	position: absolute;
	top: 16px;
	z-index: 999;
	padding: 0;
	path {
		stroke: ${ifProp('$isWhite', palette('white'), palette('gray6'))};
	}
`;
